import React from "react";
import { useParams } from "react-router";
import PatientActivityReport from "../Shared/PatientActivityReport";

const SuperAdminDoctorPatientReport = () => {
  const { id } = useParams();
  return (
    <PatientActivityReport
      userId={id}
      title="Patient Exercise & Activity Analytics"
      description="Track game scores, training frequency, and overall recovery progress"
    />
  );
};

export default SuperAdminDoctorPatientReport;
